/**
 * Utilidades geométricas de propósito general para GeoJSON en
 * EPSG:4326. Extraídas del cálculo `polygonAreaHa` que estaba
 * duplicado en varios formularios de parcela.
 */

/**
 * Área geodésica aproximada de un polígono o multi-polígono GeoJSON
 * (WGS84) en hectáreas. Precisión sub-1 % para tamaños de parcela;
 * suficiente para las sugerencias de superficie del UI (no la
 * usamos para el aforo definitivo — ese cálculo vive en el backend).
 *
 * Devuelve null si `geom` es null o no es un tipo con área.
 */
export function computeGeodesicAreaHa(
  geom: GeoJSON.Geometry | null | undefined,
): number | null {
  if (!geom) return null;
  const coordsList: number[][][] = [];
  if (geom.type === "Polygon") {
    coordsList.push(geom.coordinates[0] as unknown as number[][]);
  } else if (geom.type === "MultiPolygon") {
    for (const poly of geom.coordinates as unknown as number[][][][]) {
      coordsList.push(poly[0]);
    }
  } else {
    return null;
  }
  const R = 6378137; // WGS84 equatorial radius (m)
  const toRad = (d: number) => (d * Math.PI) / 180;
  let totalM2 = 0;
  for (const ring of coordsList) {
    let area = 0;
    for (let i = 0; i < ring.length - 1; i++) {
      const [lon1, lat1] = ring[i];
      const [lon2, lat2] = ring[i + 1];
      area +=
        (toRad(lon2) - toRad(lon1)) *
        (2 + Math.sin(toRad(lat1)) + Math.sin(toRad(lat2)));
    }
    totalM2 += Math.abs((area * R * R) / 2);
  }
  return totalM2 / 10_000;
}
